export const ReturnDeductionTaxTypes = {
    NetWinningsTax: "NetWinningsTax",
    FullReturnTax: "FullReturnTax"
};
//# sourceMappingURL=ReturnDeductionTaxTypes.js.map